import { BFormCheckbox } from 'bootstrap-vue';

export default {
    mixins: [BFormCheckbox],
    props: {
        trueLabel: {
            type: String,
            default: null,
        },
        falseLabel: {
            type: String,
            default: null,
        },
        switch: {
            type: Boolean,
            default: true,
        },
        variant: {
            type: String,
            default: 'primary',
        },
    },

    render(h) {
        const defaultSlot = this.normalizeSlot('default');

        // Generate the input element
        const on = { change: this.handleChange };

        const input = h('input', {
            ref: 'input',
            key: 'input',
            on,
            class: {
                'form-check-input': this.isPlain,
                'custom-control-input': this.isCustom,
                'is-valid': this.getState === true && !this.isBtnMode,
                'is-invalid': this.getState === false && !this.isBtnMode,
                'position-static': this.isPlain && !defaultSlot,
            },
            directives: [
                {
                    name: 'model',
                    rawName: 'v-model',
                    value: this.computedLocalChecked,
                    expression: 'computedLocalChecked',
                },
            ],
            attrs: {
                ...this.$attrs,
                id: this.safeId(),
                type: this.isRadio ? 'radio' : 'checkbox',
                name: this.getName,
                form: this.getForm,
                disabled: this.isDisabled,
                required: this.isRequired,
                autocomplete: 'off',
                'aria-required': this.isRequired || null,
                'aria-label': this.ariaLabel || null,
                'aria-labelledby': this.ariaLabelledby || null,
            },
            domProps: {
                value: this.value,
                checked: this.isChecked,
            },
        });

        // Not button mode
        let label = h();
        // If no label content in plain mode we dont render the label
        // https://github.com/bootstrap-vue/bootstrap-vue/issues/2911
        if (!(this.isPlain && !defaultSlot)) {
            label = h(
                'label',
                {
                    class: {
                        [`custom-control-label-${this.variant}`]: true,
                        'form-check-label': this.isPlain,
                        'custom-control-label': this.isCustom,
                    },
                    attrs: { for: this.safeId() },
                },
                [
                    defaultSlot,
                    h(
                        'span',
                        {
                            class: {
                                'custom-switch-label-true': this.trueLabel,
                            },
                        },
                        this.trueLabel,
                    ),
                    h(
                        'span',
                        {
                            class: {
                                'custom-switch-label-false': this.falseLabel,
                            },
                        },
                        this.falseLabel,
                    ),
                ],
            );
        }
        // Wrap it in a div
        return h(
            'div',
            {
                class: {
                    'form-check': this.isPlain,
                    'form-check-inline': this.isPlain && this.isInline,
                    'custom-control': this.isCustom,
                    'custom-control-inline': this.isCustom && this.isInline,
                    'custom-checkbox': this.isCustom && this.isCheck && !this.isSwitch,
                    'custom-switch': this.isSwitch,
                    'custom-radio': this.isCustom && this.isRadio,
                    // Temporary until Bootstrap v4 supports sizing (most likely in V5)
                    [`b-custom-control-${this.getSize}`]: Boolean(this.getSize && !this.isBtnMode),
                },
                attrs: {
                    'data-test': this.$attrs['data-test'] || null,
                },
            },
            [input, label],
        );
    },
};
